export default "__VITE_ASSET__DGl2NxVR__"